import { httpClient } from "./http-client";
import { DataClients } from "@core/types";

import UsersClient from "./users-client";
import BannersClient from "./banners-client";
import CategoriesClient from "./categories-client";
import ProductsClient from "./products-client";
import SettingsClient from "./settings-client";
import AuthClient from "./auth-client";
import OrdersClient from "./orders-client";
import PaymentMethodsClient from "./payment-methods-client";
import ShippingMethodsClient from "./shipping-methods-client";
import ShippingZonesClient from "./shipping-zones-client";
import CouponsClient from "./coupons-client";
import DeliveryDatesClient from "./delivery-dates-client";
import AddressClient from "./address-client";
import ReferralClient from "./referral-client";
import CustomerSurveyClient from "./customer-survey-client";
import CartClient from "./cart-client";
import StoriesClient from "./stories-client";
import PaymentClient from "./payment-client";
import CardsClient from "./cards-client";
import PromoClient from "./promo-client";
import RecipesClient from "./recipes-client";
import PageItemsClient from "./page-items-client";
import NotificationsClient from "./notification-client";
import ChatClient from "./chat-client";

export default {
  bannersClient: new BannersClient(httpClient),
  categoriesClient: new CategoriesClient(httpClient),
  productsClient: new ProductsClient(httpClient),
  settingsClient: new SettingsClient(httpClient),
  authClient: new AuthClient(httpClient),
  usersClient: new UsersClient(httpClient),
  ordersClient: new OrdersClient(httpClient),
  paymentMethodsClient: new PaymentMethodsClient(httpClient),
  shippingMethodsClient: new ShippingMethodsClient(httpClient),
  shippingZonesClient: new ShippingZonesClient(httpClient),
  couponsClient: new CouponsClient(httpClient),
  deliveryDatesClient: new DeliveryDatesClient(httpClient),
  addressClient: new AddressClient(httpClient),
  referralClient: new ReferralClient(httpClient),
  customerSurveyClient: new CustomerSurveyClient(httpClient),
  cartClient: new CartClient(httpClient),
  storiesClient: new StoriesClient(httpClient),
  paymentClient: new PaymentClient(httpClient),
  cardsClient: new CardsClient(httpClient),
  promoClient: new PromoClient(httpClient),
  recipeClient: new RecipesClient(httpClient),
  pageItemsClient: new PageItemsClient(httpClient),
  notificationsClient: new NotificationsClient(httpClient),
  chatClient: new ChatClient(httpClient),
} as DataClients;
